<template>
	<div class="mx-auto w-75">
		<b-tabs class="mt-3">
			<b-tab title="Manueller Versand" active>
				<b-table
						class="mt-3 border"
						:items="manualShipments"
						:fields="fields"
						hover
				>
					<template #cell(vendorId)="row">
						{{ getVendorName(row.item.vendorId) }}
					</template>

					<template #cell(boxId)="row">
						{{ row.item.boxId ? row.item.boxId : '-' }}
					</template>

					<template #cell(processedAt)="row">
						{{ row.item.processedAt ? row.item.processedAt : '-' }}
					</template>

					<template #cell(actions)="row">
						<b-button @click="confirmDelete(row.item, 'manual_shipment')" variant="secondary">
							<i class="bi bi-trash"></i>
						</b-button>
					</template>
				</b-table>
			</b-tab>

			<b-tab title="Maschinenversand">
				<b-table
						class="mt-3 border"
						:items="machineShipments"
						:fields="fields"
						hover
				>
					<template #cell(vendorId)="row">
						{{ getVendorName(row.item.vendorId) }}
					</template>

					<template #cell(boxId)="row">
						{{ row.item.boxId ? row.item.boxId : '-' }}
					</template>

					<template #cell(processedAt)="row">
						{{ row.item.processedAt ? row.item.processedAt : '-' }}
					</template>

					<template #cell(actions)="row">
						<b-button @click="confirmDelete(row.item, 'machine_shipment')" variant="secondary">
							<i class="bi bi-trash"></i>
						</b-button>
					</template>
				</b-table>
			</b-tab>
		</b-tabs>
		<modal-error-component v-model="modalError"></modal-error-component>
	</div>
</template>

<script>
import ModalErrorComponent from "./ModalErrorComponent.vue";

export default {
	name: "GoodsReceiptTableIndex",
	components: {ModalErrorComponent},
	props: {
		passedMachineShipments: {
			type: Array,
			required: true
		},
		passedManualShipments: {
			type: Array,
			required: true
		},
		passedVendors: {
			type: Object,
			required: true
		},
	},
	data() {
		return {
			manualShipments: [...this.passedManualShipments],
			machineShipments: [...this.passedMachineShipments],
			fields: [
				{key: 'id', label: 'ID', sortable: true},
				{key: 'ean', label: 'Barcode', sortable: true},
				{key: 'customerOrderId', label: 'Bestellnummer', sortable: true},
				{key: 'vendorId', label: 'Lieferant', sortable: true},
				{key: 'boxId', label: 'Kiste', sortable: true},
				{key: 'lastUpdated', label: 'Letzte Änderung', sortable: true},
				{key: 'actions', label: ''}
			],
			modalError: {
				show: false,
				message: '',
				error: '',
				title: ''
			},
		}
	},
	methods: {
		getVendorName(vendorId) {
			return this.passedVendors[vendorId] ?? vendorId;
		},

		confirmDelete(shipment, shipmentType) {
			this.$bvModal.msgBoxConfirm(
				'Möchten Sie diesen Eintrag wirklich löschen?',
				{
					title: 'Eintrag löschen',
					okTitle: 'Ja',
					cancelTitle: 'Nein',
					okVariant: 'danger',
					cancelVariant: 'secondary',
					centered: true
				}
			).then(confirmed => {
				if (confirmed) {
					this.deleteEntry(shipment, shipmentType);
				}
			});
		},

		deleteEntry(shipment, shipmentType) {
			axios.delete('/goodsreceipt/' + shipmentType + '/' + shipment.id)
				.then(() => {
					const shipments = shipmentType === 'manual_shipment'
							? this.manualShipments
							: this.machineShipments;

					const index = shipments.findIndex(item => item.id === shipment.id);

					if (index !== -1) {
						shipments.splice(index, 1);
					}
					this.$bvToast.toast('Eintrag wurde erfolgreich entfernt.', {
						title: 'Erfolgreich',
						variant: 'success',
						solid: true,
						autoHideDelay: 3000
					});
				})
				.catch(error => {
					console.log(error);
					this.modalError.show = true;
					this.modalError.title = 'Fehler beim Löschen';
					this.modalError.message = 'Beim Löschen des Eintrags ist ein Fehler aufgetreten.';
					this.modalError.error = error.response.data.message || error.message || error;
				});
		}
	}
}
</script>

<style scoped>

</style>